module.exports = __webpack_public_path__ + "static/garage_night-183a94259ed78cff2aaa33614f5dfccc.jpg";